import { Station } from '@app/core/types/stations';
import {
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum,
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum,
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum,
  usePntAppControllerGetSegmentAdOverlayByDate,
} from '@mi-front/api-v2';
import { parseRangeFromTs } from '@mi-front/core';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import AdoverlayView from './AdoverlayView';
import { filterAdoverlayData, formatAdoverlayData } from './utils';

interface IAdoverlayContainer {
  station: Station;
}

const AdoverlayContainer: React.FunctionComponent<IAdoverlayContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);

  const { data, isLoading } = usePntAppControllerGetSegmentAdOverlayByDate(
    station.slug,
    {
      from: range.from,
      to: range.to,
      withResults: PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum.true,
      sortBy: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum.date,
      sortOrder: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.desc,
    },
    {
      query: {
        select: (results) => formatAdoverlayData(filterAdoverlayData(results)),
      },
    },
  );

  return <AdoverlayView data={data} loading={isLoading} station={station} />;
};

export default AdoverlayContainer;
